import { cn } from '@/utils/classname';
import { SVGProps } from 'react';
import { fill, stroke } from './classNames';

export const SharelinkIcon = ({
  isActive,
  className,
  ...props
}: { isActive: boolean } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 20 21"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn('group', className)}
    >
      <path
        className={fill(isActive)}
        clipRule="evenodd"
        d="M18.6507 3.86C18.6507 5.439 17.3707 6.719 15.7917 6.719C14.2117 6.719 12.9307 5.439 12.9307 3.86C12.9307 2.281 14.2117 1 15.7917 1C17.3707 1 18.6507 2.281 18.6507 3.86Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.685"
      />
      <path
        className={fill(isActive)}
        clipRule="evenodd"
        d="M18.6507 16.4567C18.6507 18.0357 17.3707 19.3157 15.7917 19.3157C14.2117 19.3157 12.9307 18.0357 12.9307 16.4567C12.9307 14.8767 14.2117 13.5967 15.7917 13.5967C17.3707 13.5967 18.6507 14.8767 18.6507 16.4567Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.685"
      />
      <path
        className={fill(isActive)}
        clipRule="evenodd"
        d="M7.72 10.1549C7.72 11.7339 6.44 13.0139 4.86 13.0139C3.281 13.0139 2 11.7339 2 10.1549C2 8.5759 3.281 7.2959 4.86 7.2959C6.44 7.2959 7.72 8.5759 7.72 10.1549Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.685"
      />
      <path
        className={stroke(isActive)}
        d="M13.2493 5.14746L7.29126 8.63246"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.685"
      />
      <path
        className={stroke(isActive)}
        d="M13.2493 15.1618L7.29126 11.6768"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.685"
      />
    </svg>
  );
};
